import store from 'utils/store/withMiddleware'
import toComparisonShape from 'utils/pivot/plan/toComparisonShape'
import makeComparisonPayload from 'core/services/email/sendEmailFromAgent/comparison/makePayload'
import sendEmailFromAgent from 'core/services/email/sendEmailFromAgent'
import { sendEmailQuoteEvent } from 'core/services/email/blueshift/implementations/email-quote'

function sendComparisonViaEmail(
  valuesForm,
  agentInformation,
  config,
  salesCenterAgent,
  latitudeJson
) {
  const state = store.getState()

  const plans = (state.multiCarrierEmailPlanIds ?? []).map(id => {
    const raw = state.plans[id]
    if (!raw) throw new Error(`PPI-1399: plan ${id} not found in state.plans`)
    return toComparisonShape({
      plan: raw,
      allPlans: state.plans,
      brochures: state.brochures,
      carriers: state.carriers,
      period: raw.durations?.[0]?.policyDuration ?? 0,
      policies: 1
    })
  })

  const data = makeComparisonPayload({
    valuesForm,
    agentInformation,
    plans,
    salesCenterAgent,
    placement: config.placement,
    latitudeJson
  })

  const quote = data.message.global_merge_vars.find(
    v => v.name === 'linkToQuote'
  )?.content
  if (quote) sendEmailQuoteEvent(quote)

  return sendEmailFromAgent({ config, data })
}

export default sendComparisonViaEmail
